import { apiEndpoint } from "../utils/env";

async function fetchWithAuth(url, token, options = {}) {
  const headers = options.headers || {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  headers["Content-Type"] = headers["Content-Type"] || "application/json";
  const res = await fetch(url, { ...options, headers });
  const txt = await res.text();
  let json = null;
  try {
    json = txt ? JSON.parse(txt) : null;
  } catch {
    json = txt;
  }
  if (!res.ok) {
    const errMsg =
      json && json.message
        ? json.message
        : typeof json === "string"
        ? json
        : res.statusText;
    const error = new Error(errMsg || `Request failed: ${res.status}`);
    error.code = json && json.code ? json.code : null;
    error.status = res.status;
    error.details = json;
    throw error;
  }
  return json;
}

export async function getDocumentRelations(token, dbName, archiveNo) {
  const params = new URLSearchParams({ dbName, archiveNo });
  const url = apiEndpoint(`/api/DocumentRelation/GetRelated?${params.toString()}`);
  return fetchWithAuth(url, token, { method: "GET" });
}

export async function createDocumentRelation(token, relation) {
  const url = apiEndpoint("/api/DocumentRelation/Create");
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify(relation),
  });
}

export async function deleteDocumentRelation(token, id) {
  const url = apiEndpoint(`/api/DocumentRelation/Delete/${id}`);
  return fetchWithAuth(url, token, { method: "DELETE" });
}
